/**
 * The token-storage SEAM. Nothing above this file knows where tokens live.
 *
 * Deliberately tiny, because almost nothing is stored:
 *
 * - **Refresh token** — an `HttpOnly; Secure; SameSite=Lax` cookie on `.roo.money`, set and cleared
 *   by the server. JS cannot read it, so this file has no accessor for it at all. The browser
 *   attaches it automatically (`withCredentials` in sdk.service).
 * - **Access token** — memory only, below. Short-lived, and re-minted from the cookie on load.
 *
 * Nothing is written to `localStorage` or `sessionStorage`, on purpose. Under XSS a refresh token in
 * web storage is read once and then renewed offline from the attacker's own machine for the life of
 * the token — unrevocable, undetectable, and with no way to tell which users were hit. In a cookie
 * it cannot be read at all, so an attacker is confined to the victim's browser and to ~1-hour access
 * tokens. XSS is transient; a stolen credential is not. Web tokens are additionally capped at 28
 * days against mobile's 180. See session/PLAN.md D3/D4.
 *
 * What this does NOT buy, so nobody over-trusts it: it does not prevent XSS, and it does not stop an
 * attacker acting as the user *while their script is running*. It stops them keeping anything.
 */

/** Memory only by design — short-lived, and re-minted from the refresh cookie. */
let accessTokenInMemory: string | null = null;

export function getAccessToken(): string | null {
  return accessTokenInMemory;
}

export function setAccessToken(accessToken: string): void {
  accessTokenInMemory = accessToken;
}

export function clearAccessToken(): void {
  accessTokenInMemory = null;
}
